import { Client } from 'typesense';

// Resolve host and keys from environment when available
const nodeHost = typeof process !== 'undefined' ? (process.env?.TYPESENSE_HOST || process.env?.VITE_TYPESENSE_HOST) : undefined;
const viteHost = typeof import.meta !== 'undefined' ? ((import.meta as any).env?.VITE_TYPESENSE_HOST) : undefined;
const host = nodeHost || viteHost || 'tqpi62sg9v75l4fxp-1.a1.typesense.net';

const adminKey = typeof process !== 'undefined' ? (process.env?.TYPESENSE_ADMIN_API_KEY || '') : '';
const resolvedAdminKey = adminKey || 'e80vd5pAVfIDIV8KquQ4biGJYtdlaKl3';

const searchKey = typeof import.meta !== 'undefined' ? ((import.meta as any).env?.VITE_TYPESENSE_SEARCH_KEY || '') : '';
const resolvedSearchKey = searchKey || 'NFnOwtM0Xwh0lesDuDoI5xFTJLxtmcBH';

const typesenseClient = new Client({
  nodes: [
    {
      host,
      port: 443,
      protocol: 'https',
    },
  ],
  apiKey: resolvedAdminKey,
  connectionTimeoutSeconds: 10,
});

// Search-only client for frontend operations
const typesenseSearchClient = new Client({
  nodes: [
    {
      host,
      port: 443,
      protocol: 'https',
    },
  ],
  apiKey: resolvedSearchKey, // Prefer Vite env, fallback to existing
  connectionTimeoutSeconds: 10,
});

export { typesenseClient, typesenseSearchClient };